import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { ReactiveComponentModule } from '@ngrx/component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgPipesModule } from 'ngx-pipes';
import { DialerClientModule } from '../dialer-client/dialer-client.module';
import { PathModule } from '../path/path.module';
import { SharedModule } from '../shared/shared.module';
import { TaskModule } from '../task/task.module';
import { PathTestEditComponent } from './path-test-edit/path-test-edit.component';
import { PathTestGroupComponent } from './path-test-group/path-test-group.component';
import { PathTestHeaderComponent } from './path-test-header/path-test-header.component';
import { PathTestLogComponent } from './path-test-log/path-test-log.component';
import { PathTestOverlayComponent } from './path-test-plotter/path-test-overlay.component';
import { PathTestPlotterComponent } from './path-test-plotter/path-test-plotter.component';
import { PathTestPointMarkerPopupComponent } from './path-test-plotter/path-test-point-marker-popup/path-test-point-marker-popup.component';
import { PathTestPointListComponent, PathTestPointSeqCommentsComponent } from './path-test-point/path-test-point-list/path-test-point-list.component';
import { PathTestPointLogComponent } from './path-test-point/path-test-point-log/path-test-point-log.component';
import { PathTestPointLocatorComponent, PathTestPointPaginatorComponent } from './path-test-point/path-test-point-paginator/path-test-point-paginator.component';
import { PathTestPointSeqDataEditorComponent } from './path-test-point/path-test-point-seq-data-editor/path-test-point-seq-data-editor.component';
import { PathTestPointSeqStatusEditorComponent, SeqToStatusIdPipe } from './path-test-point/path-test-point-seq-status-editor/path-test-point-seq-status-editor.component';
import { PathTestPointSeqStatusComponent } from './path-test-point/path-test-point-seq-status/path-test-point-seq-status.component';
import { PathTestPointComponent } from './path-test-point/path-test-point.component';
import { PathTestComponent } from './path-test.component';
import { PostProcessingModule } from "../post-processing/post-processing.module";
import { ScoutModule } from "../scout/scout.module";
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    PathTestComponent,
    PathTestLogComponent,
    PathTestHeaderComponent,
    PathTestEditComponent,
    PathTestPlotterComponent,
    PathTestOverlayComponent,
    PathTestPointMarkerPopupComponent,
    PathTestPointPaginatorComponent,
    PathTestPointSeqStatusEditorComponent,
    PathTestPointSeqDataEditorComponent,
    PathTestPointLogComponent,
    PathTestPointLocatorComponent,
    PathTestPointComponent,
    SeqToStatusIdPipe,
    PathTestPointListComponent,
    PathTestGroupComponent,
    PathTestPointSeqCommentsComponent,
    PathTestPointSeqStatusComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ReactiveComponentModule,
    LeafletModule,
    DragDropModule,
    BsDropdownModule.forRoot(),
    SharedModule,
    PathModule,
    TaskModule,
    DialerClientModule,
    PostProcessingModule,
    NgPipesModule,
    ScoutModule
],
    exports: [
        PathTestComponent, PathTestEditComponent, PathTestGroupComponent, PathTestLogComponent
    ],
  entryComponents: [ PathTestPointMarkerPopupComponent ]
})
export class PathTestModule {
  constructor(private injector: Injector) {
    // For path-test-plotter marker popup angular integration with leaflet map
    const popupElement = createCustomElement(PathTestPointMarkerPopupComponent, {injector});
    customElements.define('app-path-test-point-marker-popup-element', popupElement);
  }
 }
